module.exports = __webpack_public_path__ + "img/2.490930f6.png";